import { lazy } from 'react';
import { Outlet, Route } from 'react-router-dom';
import { GeneralLayout } from '@layouts/general';
import React from 'react';
import { paths } from '@routes/paths';

// ----------------------------------------------------------------------


// ----------------------------------------------------------------------

export const authRoutes = (
  <Route element={<GeneralLayout />}>
  </Route>
);
